const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
const SET_FILTER_DATA = 'SET_FILTER_DATA'
const SET_RENEW_SEND_DATA = 'SET_RENEW_SEND_DATA'

const state = {
  activeTab:'',
  getfilterData: {},
  renewSendData:''
}

const mutations = {
  [SET_ACTIVE_TAB]: (state, value) => {
    state.activeTab = value
  },
  [SET_FILTER_DATA]: (state, value) => {
    state.getfilterData = value
  },
  [SET_RENEW_SEND_DATA]: (state, value) => {
    state.renewSendData = value
  }
}

const actions = {
  setActiveTab({ commit }, val) {
    commit(SET_ACTIVE_TAB, val)
  },
  setFilterData({ commit }, val) {
    commit(SET_FILTER_DATA, val)
  },
  setRenewSendData({ commit }, val) {
    commit(SET_RENEW_SEND_DATA, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
